import React from 'react';

import { Settings } from 'components';

export const AdminSettingsPage: React.FC = () => <Settings />;
